<script>
  export let content = {
    superHeroImgSrc: '',
    superHeroImgAltTxt: '',
    titleOne: '',
    titleTwo: '',
    videoSrc: '',
    videoThumbnailImgSrc: '',
    videoThumbnailAltTxt: '',
    learningPathStarImgSrc: '',
    learningPathStarAltTxt: '',
    learningPathTitle: '',
    learningPathExplainer: '',
    learningPathImgs: [
      {
        media: '',
        src: '',
        alt: ''
      }
    ],
    quotationMarksImgSrc: '',
    quotationMarksAltTxt: '',
    testimonials: [{
      title: '',
      content: '',
      credit: ''
    }]
  };

  import { openModal } from 'svelte-modals';
  import ModalHomeVideo from './ModalHomeVideo.svelte';

  function playVideo() {
    openModal(ModalHomeVideo, {
      videoSrc: content.videoSrc
    });
  }

</script>

<section class="font-poppins pr-[2rem] pl-[2rem] relative bg-[#e7f3fd] z-10 pt-[2rem] pb-32 sm:pb-[6rem] sm:mt-[-1rem] sm:pt-[5rem] md:pb-[20rem]">
  <div class="flex flex-col items-center gap-[5rem] sm:gap-28 md:gap-[10rem] xl:gap-[12rem]">

    <div class="flex flex-col items-center">
      <div class="flex flex-col items-center sm:flex-row-reverse sm:items-end">
        <img class="mr-[14rem] sm:mr-[2rem] w-[9.5rem] sm:w-[26.3rem] mb-[0.5rem]" width="307" height="272" src={content.superHeroImgSrc} alt={content.superHeroImgAltTxt}>
        <div class="mt-[-3rem] mb-[1.5rem] sm:mt-4">
          <h3 class="leading-none bg-gradient-to-r from-[#0395FF] to-[#0494F5] bg-clip-text text-transparent text-[2.5rem] font-bold text-end sm:text-[4.5rem] md:text-[5rem]">{content.titleOne}</h3>
          <h3 class="leading-none bg-gradient-to-r from-[#0395FF] to-[#0494F5] bg-clip-text text-transparent text-[2.5rem] font-bold text-end sm:text-[4.5rem] md:text-[5rem] max-w-none sm:max-w-[30rem] md:max-w-[unset]">{content.titleTwo}</h3>
        </div>
      </div>
      <img loading="lazy" id="video-start-button" class="w-[30.4rem] cursor-pointer sm:w-[59rem] md:w-[84.7rem] sm:mt-[-1rem]" width="307" height="272" src={content.videoThumbnailImgSrc} alt={content.videoThumbnailAltTxt} data-track-id="video-start-button" on:click={playVideo} >
    </div>

    <div class="flex flex-col items-center gap-[3rem] sm:gap-12 md:grid md:grid-rows-[auto_auto] md:grid-cols-[38.6rem_1fr] md:gap-y-8 md:gap-x-16 md:grid-areas-['title_description'_'image_image']">
      <div class="title-container flex flex-col items-center text-center pb-2 md:pl-[2rem] md:items-start md:text-start md:pb-0 md:grid-area-title">
        <img loading="lazy" class="w-[17.6rem] sm:w-[32.6rem] md:w-[35.6rem]" width="30" height="30" src="{content.learningPathStarImgSrc}" alt="{content.learningPathStarAltTxt}">
        <h2 class="title bg-gradient-to-r from-[#0395FF] to-[#0494F5] bg-clip-text text-transparent text-[2.7rem] font-bold sm:text-[4.5rem] md:text-[5rem] tracking-normal leading-[3.4rem] sm:leading-[6.3rem]">{@html content.learningPathTitle}</h2>
      </div>
      <p class="text-[#63637A] text-center md:text-start
       max-w-[28rem] text-[1.4rem] leading-[1.9rem] font-regular sm:text-[2rem] sm:leading-[2.8rem] sm:max-w-[58.8rem] md:max-w-[71.2rem] md:text-[2.25rem] md:leading-[3rem] md:grid-area-description">
        {@html content.learningPathExplainer}
      </p>
      <picture class="w-full max-w-[29rem] sm:max-w-[59.8rem] md:max-w-[107.4rem]" style="grid-area: image;">
        {#each content.learningPathImgs as image}
          <source media="{image.media}" srcset="{image.src}" />
          {/each}
        <img loading="lazy" class="w-full" width="428" height="69" src="{content.learningPathImgs[0].src}" alt="{content.learningPathImgs[0].alt}">
      </picture>
    </div>

    <div class="flex flex-col items-center gap-[4rem] mb-[5rem] sm:flex-row sm:gap-[5rem]">
      {#each content.testimonials as testimonial}
        <div class="italic flex flex-col items-center text-center text-[#63637A] max-w-[27.2rem] md:max-w-[48rem]">
          <img loading="lazy" class="quotes w-[3.6rem] mb-[1.4rem] md:w-[6.3rem] md:mb-8" src="{content.quotationMarksImgSrc}" width="600" height="443" alt="{content.quotationMarksAltTxt}">
          <h3 class="text-[1.8rem] font-bold mb-4 md:text-[3rem] md:mb-6">{testimonial.title}</h3>
          <p class="text-[1.4rem] font-regular leading-[1.8rem] mb-[1.5rem] md:text-[1.8rem] md:leading-[3rem] md:mb-8">{testimonial.content}</p>
          <p class="author text-[1.2rem] font-regular text-[#0496ff] md:text-[1.4rem]">{testimonial.credit}</p>
        </div>
      {/each}
    </div>

  </div>
</section>
